import React, { useState } from 'react';
import { useTheme } from '../ThemeContext';
import PODCAST_SCRIPTS from '../data/podcastScripts';

const EPISODES = [
  { num: 1, title: '</doposcuola_sport>', topic: 'Il campo da gioco e la prima aula', duration: '~7 min' },
  { num: 2, title: '</stage_r€tribuiti>', topic: 'Il lavoro si impara lavorando. Pagati.', duration: '~7 min' },
  { num: 3, title: '</formazione_digitale>', topic: 'La prima elementare digitale. Per davvero.', duration: '~7 min' },
  { num: 4, title: '</spazi_pubblici>', topic: 'Riqualifichiamo i luoghi. Riqualifichiamo le persone.', duration: '~7 min' },
  { num: 5, title: '</inclusione>', topic: 'Nessuno escluso, nessuno invisibile.', duration: '~7 min' },
  { num: 6, title: '</mentore>', topic: "L'AI che risponde. Gratis. A tutti.", duration: '~7 min' },
  { num: 7, title: '</cittadino>', topic: 'I tuoi diritti non finiscono dove inizia internet.', duration: '~7 min' },
  { num: 8, title: '</archivio>', topic: 'Salviamo la sapienza popolare prima che sia troppo tardi.', duration: '~7 min' },
  { num: 9, title: '</generazioni>', topic: 'Il ponte tra tutte le generazioni.', duration: '~7 min' },
];

export default function PodcastPage() {
  const { isInstitutional } = useTheme();
  const isDark = !isInstitutional;
  const green = '#00FF41';
  const [expandedEp, setExpandedEp] = useState(null);
  const [showScript, setShowScript] = useState(null);

  const bg = isDark ? 'bg-[#050505]' : 'bg-[#FAF9F6]';
  const cardBg = isDark ? 'bg-[#0a0a0a] border-[#1a1a1a]' : 'bg-white border-[#E2DED6]';
  const text = isDark ? 'text-white' : 'text-[#1B2A4A]';
  const textSub = isDark ? 'text-zinc-400' : 'text-[#5A6B80]';
  const accent = isDark ? green : '#C4532D';

  const getScript = (num) => {
    const ep = PODCAST_SCRIPTS.find(s => s.num === num);
    return ep ? ep.script : '';
  };

  return (
    <main data-testid="podcast-page" className={`min-h-screen pt-20 pb-16 ${bg} ${text}`}>
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="font-mono font-black text-3xl md:text-5xl mb-3" style={{ color: accent, textShadow: isDark ? '0 0 20px rgba(0,255,65,0.3)' : 'none' }} data-testid="podcast-title">
            &lt;/podcast&gt;
          </p>
          <p className="wave-text wave-text-slow" style={{ fontFamily: "'Georgia', serif", fontWeight: 700, fontStyle: 'italic', fontSize: '14px' }}>
            {'la voce di AI_covo.tech'.split('').map((c, i) => (
              <span key={i} style={{ color: isDark ? '#fff' : '#1B2A4A' }}>{c === ' ' ? '\u00A0' : c}</span>
            ))}
          </p>
          <p className={`${textSub} text-sm mt-4 max-w-lg mx-auto`}>
            9 pillole da ~7 minuti. Una per ogni sezione di &lt;/AI_covo.tech&gt;®. Storie, dati, visione.
          </p>
          <div className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 border rounded-full" style={{ borderColor: `${accent}44` }}>
            <span className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: accent }} />
            <span className="font-mono text-[10px]" style={{ color: accent }}>TESTI PRONTI — IN ATTESA DI REGISTRAZIONE</span>
          </div>
        </div>

        <div className="space-y-3">
          {EPISODES.map(ep => {
            const isExpanded = expandedEp === ep.num;
            const isScriptOpen = showScript === ep.num;
            return (
              <div key={ep.num} className={`${cardBg} border rounded-xl overflow-hidden transition-all`} data-testid={`podcast-ep-${ep.num}`}>
                <button onClick={() => { setExpandedEp(isExpanded ? null : ep.num); if (isExpanded) setShowScript(null); }} className="w-full flex items-center gap-4 p-4 text-left">
                  <span className="font-mono font-black text-xl w-10 text-center shrink-0" style={{ color: accent }}>
                    {String(ep.num).padStart(2, '0')}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="font-mono font-bold text-sm" style={{ color: accent }}>{ep.title}</p>
                    <p className={`${textSub} text-xs`}>{ep.topic}</p>
                  </div>
                  <span className="font-mono text-[10px] px-2 py-1 rounded-full border shrink-0" style={{ borderColor: accent + '44', color: accent }}>
                    {ep.duration}
                  </span>
                  <span className={`${textSub} transition-transform ${isExpanded ? 'rotate-180' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 9l6 6 6-6"/></svg>
                  </span>
                </button>
                {isExpanded && (
                  <div className="px-4 pb-4">
                    <div className="ml-14">
                      {/* Toggle script */}
                      <button
                        data-testid={`podcast-script-btn-${ep.num}`}
                        onClick={() => setShowScript(isScriptOpen ? null : ep.num)}
                        className="font-mono text-[10px] px-3 py-1.5 border rounded transition-all mb-3"
                        style={{
                          borderColor: isScriptOpen ? accent : '#FFD700',
                          color: isScriptOpen ? '#000' : '#FFD700',
                          backgroundColor: isScriptOpen ? accent : 'transparent',
                        }}
                      >
                        {isScriptOpen ? 'CHIUDI TESTO' : 'LEGGI TESTO EPISODIO'}
                      </button>

                      {isScriptOpen && (
                        <div className="mt-2 p-4 border rounded-lg" style={{ borderColor: `${accent}22`, backgroundColor: isDark ? '#0a0a0a' : '#f5f5f0' }}>
                          <div className="flex items-center justify-between mb-4">
                            <p className="font-mono text-[10px] uppercase tracking-wider" style={{ color: accent }}>
                              TESTO PER LETTURA — EPISODIO {String(ep.num).padStart(2, '0')}
                            </p>
                            <button
                              onClick={() => {
                                navigator.clipboard.writeText(getScript(ep.num));
                              }}
                              className="font-mono text-[10px] px-2 py-1 border rounded transition-colors"
                              style={{ borderColor: '#FFD700', color: '#FFD700' }}
                            >
                              COPIA
                            </button>
                          </div>
                          <div className={`${textSub} text-sm leading-[1.9] whitespace-pre-line`} style={{ fontFamily: "'Georgia', 'Times New Roman', serif" }}>
                            {getScript(ep.num)}
                          </div>
                        </div>
                      )}

                      {!isScriptOpen && (
                        <div className="flex gap-2 flex-wrap">
                          <span className="font-mono text-[10px] px-2 py-1 rounded-full border" style={{ borderColor: '#FFD700' + '44', color: '#FFD700' }}>
                            Testo pronto
                          </span>
                          <span className="font-mono text-[10px] px-2 py-1 rounded-full border" style={{ borderColor: accent + '22', color: textSub }}>
                            Audio in attesa
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className={`${cardBg} border rounded-xl p-5 mt-8 text-center`}>
          <p className="font-mono font-bold text-sm mb-2" style={{ color: accent }}>&lt;/prossimi_passi&gt;</p>
          <p className={`${textSub} text-xs`}>
            Tutti i testi sono pronti per la registrazione. Ogni episodio ha il pulsante "LEGGI TESTO" per la lettura in studio. Player audio integrato appena i file saranno pronti.
          </p>
        </div>
      </div>
    </main>
  );
}
